import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'

import { AppLoader } from './AppLoader'
import { AppRouter } from './AppRouter'
import { AppAuthRouter } from './AppAuthRouter'
import { AppNotHealthy } from './AppNotHealthy'
import { MoySkladAppRoute } from './MoySkladAppRoute'

import { useLogic, useStore } from '../hooks/storeHook'
import { useBoolState, useLazyEffect } from '../hooks/commonHooks'

import { appConfig } from '../common/devUtils'
import { isMoySkladAppRoute } from '../common/appRoutes'

export const AppContent =
  observer(() => {
    const logic = useLogic()
    const {user} = useStore()

    const [isLoaded, setLoaded] = useBoolState()
    const [isApiHealthy, setApiHealthy] = useState(false)
    const [shouldShowChat, setShouldShowChat] = useState(false)

    useLazyEffect(async () => {
      let disableChat = false

      try {
        const isHealthy = await logic.healthCheck()
        setApiHealthy(isHealthy)

        if (!isHealthy) {
          return
        }

        // MS app has a different auth flow
        if (!isMoySkladAppRoute()) {
          const newUser = await logic.checkAuth()
          disableChat = !!newUser?.isSuperAdmin || !!newUser?.isImpersonating
        }
      } finally {
        setLoaded()
        setShouldShowChat(appConfig.isProduction && !disableChat)
      }
    })

    useLazyEffect(() => {
      if (isMoySkladAppRoute()) {
        window.document.documentElement.classList.add('ms-app')
      }
    })

    useEffect(() => {
      if (!isLoaded || !isApiHealthy || !shouldShowChat) {
        return
      }

      document.body.classList.add('umnico-visible')

      return () => {
        document.body.classList.remove('umnico-visible')
      }
    }, [isLoaded, isApiHealthy, shouldShowChat])

    if (!isLoaded) {
      return <AppLoader/>
    }

    if (!isApiHealthy) {
      return <AppNotHealthy/>
    }

    if (!user) {
      return <AppAuthRouter/>
    }

    if (user.moySkladAppState != null) {
      return <MoySkladAppRoute/>
    }

    return <AppRouter/>
  })